
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-penilik/pejabat-penilai-kinerja/perencanaan",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-penilik/pejabat-penilai-kinerja/perencanaan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-penilik/pejabat-penilai-kinerja/perencanaan"])
      });
    }
  